<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-blurb" id="blur-1"><a href="#/SavingRoomForD_blur1">NOVELS BY K. C. CONSTANTINE</a></p>
<p class="toc-front" id="copy-1"><span href="#/SavingRoomForD_copy" title="Link target outside of Sample">Copyright Page</span></p>
<p class="toc-chapter" id="chap-1"><a href="#/SavingRoomForD_chap1">1993</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/SavingRoomForD_chap2">1999</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/SavingRoomForD_chap3"></a></p>
<p class="toc-chapter" id="chap-4"><a href="#/SavingRoomForD_chap4"></a></p>
<p class="toc-chapter" id="chap-5"><a href="#/SavingRoomForD_chap5"></a></p>
<p class="toc-chapter" id="chap-6"><a href="#/SavingRoomForD_chap6"></a></p>
<p class="toc-chapter" id="chap-7"><a href="#/SavingRoomForD_chap7"></a></p>
<p class="toc-chapter" id="chap-8"><a href="#/SavingRoomForD_chap8"></a></p>
<p class="toc-chapter" id="chap-9"><a href="#/SavingRoomForD_chap9"></a></p>
<p class="toc-chapter" id="chap-10"><a href="#/SavingRoomForD_chap10"></a></p>
<p class="toc-chapter" id="chap-11"><a href="#/SavingRoomForD_chap11"></a></p>
<p class="toc-chapter" id="chap-12"><a href="#/SavingRoomForD_chap12"></a></p>
<p class="toc-chapter" id="chap-13"><a href="#/SavingRoomForD_chap13"></a></p>
<p class="toc-chapter" id="chap-14"><a href="#/SavingRoomForD_chap14"></a></p>
<p class="toc-chapter" id="chap-15"><a href="#/SavingRoomForD_chap15"></a></p>
<p class="toc-chapter" id="chap-16"><a href="#/SavingRoomForD_chap16"></a></p>
<p class="toc-chapter" id="chap-17"><a href="#/SavingRoomForD_chap17"></a></p>
<p class="toc-chapter" id="chap-18"><a href="#/SavingRoomForD_chap18"></a></p>
<p class="toc-chapter" id="chap-19"><a href="#/SavingRoomForD_chap19"></a></p>
<p class="toc-chapter" id="chap-20"><a href="#/SavingRoomForD_chap20"></a></p>
<p class="toc-chapter" id="chap-21"><a href="#/SavingRoomForD_chap21"></a></p>
<p class="toc-readinggroup" id="read-1"><a href="#/SavingRoomForD_read1">CRITICAL ACCLAIM FOR K. C. CONSTANTINE’S PREVIOUS NOVEL, GRIEVANCE</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SavingRoomForD_toc.vue?15312349